module.exports = __webpack_public_path__ + "img/8th-wall.8c19ab5e.png";